import { e as mobileLink, c as mobileTypography } from '../base/typography-dd13a6be.js';
import { m as mobileSpacing, b as mobileSpacingValues } from '../base/spacing-b4d393ed.js';
import { m as mobileButton } from '../component/button-2dbc0f97.js';
import { m as mobileDividerStyles } from '../component/divider-989b8bca.js';
import { m as mobileDropdownStyles } from '../component/dropdown-3dd17c54.js';
import { m as mobileHelptipStyles } from '../component/helptip-9911c1d4.js';
import { m as mobileInputStyles } from '../component/input-fead28c1.js';
import { m as mobileTagStyles } from '../component/tag-208660fb.js';
import { m as mobileTouchLink } from '../component/touchLink-b41f7d12.js';
import { m as mobileTree } from '../component/tree-bd8dcfc6.js';
import { m as mobileRadioStyles } from '../component/radio-c6d5b40c.js';
import { m as mobileSearchInputStyles } from '../component/searchInput-c93f3adc.js';
import { m as mobileAlertStyles } from '../component/alert-24b55293.js';
import { m as mobileCheckboxStyles } from '../component/checkbox-23cad0c2.js';
import { m as mobileTabNavigationStyles } from '../component/tabNavigation-54c6187a.js';
import { m as mobilePagination } from '../component/pagination-4f979da8.js';
import { m as mobilePill } from '../component/pillLegacy-189bffbc.js';
import { m as mobilePill$1 } from '../component/pill-9464e037.js';
import { m as mobileTableStyles } from '../component/table-47ed451c.js';
import { m as mobileDatepickerStyles } from '../component/datepicker-a5c254bc.js';
import { m as mobileSwitchStyles } from '../component/switch-286f2231.js';

const mobileMediaQuery = '(orientation: portrait) and (max-width: 575.98px) and (pointer: coarse), (orientation: landscape) and (max-height: 575.98px) and (pointer: coarse)';
const notMobileMediaQuery = 'all and (orientation: portrait) and (min-width: 576px), all and (orientation: landscape) and (min-height: 576px), all and (pointer: fine)';
const theme = {
  mobile: {
    mediaQuery: mobileMediaQuery,
    inverseMediaQuery: notMobileMediaQuery,
    spacing: mobileSpacing,
    spacingValues: mobileSpacingValues,
    link: mobileLink
  },
  globals: {
    mobile: {
      link: mobileLink // DEPRECATE
    }
  },

  typography: mobileTypography,
  button: mobileButton,
  divider: mobileDividerStyles,
  dropdown: mobileDropdownStyles,
  tag: mobileTagStyles,
  form: {
    input: mobileInputStyles,
    radio: mobileRadioStyles,
    search: mobileSearchInputStyles,
    checkbox: mobileCheckboxStyles
  },
  message: mobileAlertStyles,
  touchLink: mobileTouchLink,
  tree: mobileTree,
  navigation: {
    tabs: mobileTabNavigationStyles
  },
  switch: mobileSwitchStyles,
  pagination: mobilePagination,
  pillLegacy: mobilePill,
  pillv2Beta: mobilePill$1,
  // adding in for TropicalUI support, which references this theme value
  pill: mobilePill$1,
  table: mobileTableStyles,
  datepicker: mobileDatepickerStyles,
  helptip: mobileHelptipStyles
};
var defaultMobileTheme = theme;

export { defaultMobileTheme as d };
//# sourceMappingURL=mobile-b53ec285.js.map
